module.exports = __webpack_public_path__ + "static/media/didi_playing_baja_eye.d7bb492b.gif";